import { RefCallback, useCallback, useEffect } from 'react'
import { isEmpty } from 'ramda'

import { Table, Td, Tr } from 'app/common/ui-components/table'
import { useCompensationStatementsChangeLog } from 'app/dataProviders/cafeteria/compensation/statements/hooks'
import { SkeletonLoadingTBody, StatusMessage } from 'app/common/templates-next/page-template'
import { useDraftWithdrawToParentActions } from 'app/dataProviders/cafeteria/compensation/withdraw/toParent/hooks'

import { WithdrawDraftDownload } from '../../../_common/WithdrawDraftDownload'
import styles from './SubTableInfo.scss'


const tdProps = (num: number, hasClass: boolean) => (
  hasClass ? { className: `index_${num}` } : {}
)

type Props = {
  ID: string
  loading: boolean
  beforeLoadData: (pause?: number) => Promise<void>
  afterLoadData: () => void
  headerRef: RefCallback<'tr'>
}

export const SubTableInfo = ({
  ID,
  loading: pauseBeforeLoad,
  beforeLoadData,
  afterLoadData,
  headerRef,
}: Props) => {
  const requestLogOptions = { params: { statementID: ID }, autoload: false }
  const { request, changeLog, loading: dataLoading } = useCompensationStatementsChangeLog(requestLogOptions)

  const loading = pauseBeforeLoad || dataLoading
  const nothing = isEmpty(changeLog)

  const { downloadDraft } = useDraftWithdrawToParentActions()
  const downloadStatement = useCallback(async () => {
    return downloadDraft({ withdrawID: ID })
  }, [ID, downloadDraft])

  useEffect(() => {
    (async () => {
      await beforeLoadData()
      await request()
      afterLoadData()
    })()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Table wide>
      <tbody>
        {loading && <SkeletonLoadingTBody rows={3} columns={4} onlyRows />}

        {!loading && nothing && <StatusMessage asTableRow>{'Нет данных'}</StatusMessage>}

        {!loading && !nothing && changeLog.map(({ date, comment }, index) => {
          const props = !index ? { reference: headerRef } : {}

          return (
            <Tr key={date.toString()} hoverHighlighted={false} {...props} alignTop>
              {!index
                && <Td {...tdProps(0, !index)} rowSpan={changeLog.length} alignCenter>
                  <WithdrawDraftDownload onClick={downloadStatement} className={styles.downloadLink} />
                </Td>}

              <Td {...tdProps(1, !index)} ignoreFirstChild>
                {date.getString('DD.MM.YYYY hh:mm')}
              </Td>

              <Td colSpan={2} alignRight>
                {comment}
              </Td>
            </Tr>
          )
        })}
      </tbody>
    </Table>
  )
}
